module.exports = __webpack_public_path__ + "static/media/arrival-icon.76dc6ee4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrival-icon.svg
// module id = 411
// module chunks = 0